/**
 * Price-feed status, published by the feeder (Redis `feeds:status`) and shown in Admin → Feeds, so
 * staff can see which instruments price from a live upstream and which show an indicative (mock)
 * price, and why.
 */
export const FEED_REASON_TEXT = {
    no_key: 'No provider in its routing has a key: add one in Admin → Data providers',
    forced_mock: 'FEEDS_FORCE_MOCK is on',
    rejected: 'The provider refused this symbol',
    adapter_down: 'The provider connection is down',
    no_slot: 'No provider in its routing has room for it on its current plan',
    silent: 'No quotes from the provider while the market is open',
    no_rate: 'Waiting for the USD rate of the price currency',
};
/** Redis key the feeder refreshes every few seconds (expires when the feeder stops). */
export const FEEDS_STATUS_KEY = 'feeds:status';
export const FEEDS_STATUS_TTL_SEC = 60;
//# sourceMappingURL=feeds.js.map